import { Link } from 'react-router-dom';
import React, { FC } from 'react';
import { createUseStyles } from 'react-jss';
import { IconType } from '@react-icons/all-files/lib';

const useStyles = createUseStyles({
  root: {
    fontSize: 15,
    marginBottom: '1rem',
    paddingLeft: 25,
    paddingRight: 25,
    color: '#8391a2 !important',
    display: 'flex',
    '&:hover': {
      color: '#bccee4 !important',
    },
  },
  icon: {
    fontSize: 18,
    position: 'relative',
  },
  badge: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'end',
    position: 'absolute',
    top: -3,
    right: -4,
    borderRadius: '50%',
    height: 13,
    width: 13,
    fontSize: 8,
    fontWeight: 700,
    color: 'white',
    backgroundColor: '#fa5c7c',
  },
  label: {
    marginLeft: 10,
    color: 'inherit',
    '-webkit-transform': ({ collapsed }) => `rotateY(${collapsed ? -90 : 0}deg)`,
    transform: ({ collapsed }) => `rotateY(${collapsed ? -90 : 0}deg)`,
    opacity: ({ collapsed }) => (collapsed ? 0 : 1),
    transformOrigin: '0 0',
    transition: 'all .3s ease-in-out',
  },
});

interface Props {
  notificationTotal?: number;
  collapsed?: boolean;
  link: string;
  icon: IconType;
  label: string;
  onClick?: () => void;
}

const MenuItem: FC<Props> = ({ notificationTotal, collapsed, link, icon, label, onClick }) => {
  const classes = useStyles({ collapsed });

  const Icon = icon;

  const hasNotification = (notificationTotal || 0) > 0;

  return (
    <Link className={classes.root} to={link} onClick={onClick}>
      <span className={classes.icon}>
        {/*@ts-ignore*/}
        <Icon style={{ fill: '#8391a2' }} />
        {hasNotification && <span className={classes.badge}>{notificationTotal}</span>}
      </span>
      <div className={classes.label}>{label}</div>
    </Link>
  );
};

export default MenuItem;
